import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../../store/reportStore'
import { withLocalize, Translate } from "react-localize-redux";
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { PngFlag } from '../../common/pngFlag';
import RelationLink from '../relations/relationLink';
import OldStyleSection from '../../common/oldStyleSection';
import ExcelExportButton from '../../common/excelExportButton';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';
import SvgEssMultipleSubject from "../../../img/EssMultipleSubject";
import CustomTooltip from "../../common/customTooltip";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BbPopover from '../../common/popover'

import "./economicGroup.scss"

class EconomicGroupFinalOwners extends React.Component {
    state = {
        initialized: false,
        filter: '',
        share: 25,
        lastDuplicateClickedId: null
    };

    render() {
        let finalBenefitUsers = !isNullOrUndefined(this.props.data) ? this.props.data.finalBenefitUsers : [];
        const hasFilterInProps = !isNullOrUndefined(this.props.economicGroupSettings) && !isNullOrUndefined(this.props.economicGroupSettings.filter);
        const hasShareInProps = !isNullOrUndefined(this.props.economicGroupSettings) && !isNullOrUndefined(this.props.economicGroupSettings.share);
        let ni = !isNullOrUndefined(this.props.data) ? this.props.data.negativeInfoList : [];
        return <>

            {this.renderFinalBenefitsUsers(finalBenefitUsers)}
            {this.renderCompanies(finalBenefitUsers)}
            {this.renderNegativeInfoLegend(ni)}

            <ExcelExportButton link="economic-group-final-owners" entityId={this.props.id} report={this.props.reportType}   
             additionalParams={{ filter: hasFilterInProps ? this.props.economicGroupSettings.filter : this.state.filter, share: hasShareInProps ? this.props.economicGroupSettings.share : this.state.share}}               
                />
        </>
    }


    renderFinalBenefitsUsers = (users) => {
        if (isNullOrUndefined(users))
            users = [];

        return (
            <OldStyleSection name={this.props.translate("Report.EconomicGroup.Settings.FinalBenefitsUsers")}
                hasData={!isNullOrUndefined(users) && users.length > 0} isBold isOpen>
                <OldStyleTableWithHistory tableColumns={5} actualData={users} stripped resolveExpanded={this.props.resolveExpanded}
                    head={() => <thead>
                        <tr>
                            <th style={{ width: "3.5em" }}></th>
                            <th style={{ width: "30%" }}><Translate id="Report.EconomicGroup.FinalBenefitsUser.Name" /></th>
                            <th style={{ width: "20%" }}><Translate id="Report.EconomicGroup.FinalBenefitsUser.Relation" /></th>
                            <th><Translate id="Report.EconomicGroup.FinalBenefitsUser.Address" /></th>
                            <th style={{ width: "10%" }}><Translate id="Report.Common.Source" /></th>
                            <th style={{ width: "3em", fontSize: "1.15em" }}>
                                <BbPopover title={this.props.translate("Report.ESS.Owner.Tooltip.Header")} content={this.props.translate("Report.ESS.Owner.Tooltip")} placement="left" targetId="ESS-owner-tooltip-popover">
                                    <span href="#" className="icon-gray print-hidden" id="ESS-owner-tooltip-popover" style={{ cursor: "pointer" }}><FontAwesomeIcon icon="question-circle" /></span>
                                </BbPopover>
                            </th>

                        </tr>
                    </thead>}
                    actualRow={(r) => <tr key={r.id} className="colorize">
                        <td className="flag"><PngFlag countryCode={r.countryCode} title={r.countryName} /></td>
                        <td>{r.name}</td>
                        <td>{isNullOrUndefined(r.function) ? r.relationName : r.relationName + " - " + r.function}</td>
                        <td>{r.address}</td>
                        <td title={r.sourceDescription}>{r.sourceShortening}</td>
                    </tr>}
                />
            </OldStyleSection>
        );
    }

    renderNegativeInfoLegend = (ni) => {
        if (isNullOrUndefined(ni) || ni.length === 0)
            return null;

        return (
            <>
                <hr />
                <OldStyleSection name={this.props.translate("Report.EconomicGroup.Legend.NI")} hasData isBold>
                    <OldStyleTableWithHistory tableColumns={3} actualData={ni} stripped resolveExpanded={this.props.resolveExpanded}
                        head={() => <thead>
                            <tr>
                                <th><Translate id="Report.EconomicGroup.Legend.NI.Shortening" /></th>
                                <th><Translate id="Report.EconomicGroup.Legend.NI.Description" /></th>
                                <th><Translate id="Report.EconomicGroup.Legend.NI.Source" /></th>
                            </tr>
                        </thead>}
                        actualRow={(r) => <tr key={r.id} className="colorize">
                            <td>{r.shortening}</td>
                            <td>{r.description}</td>
                            <td>{r.source}</td>
                        </tr>}
                    />
                </OldStyleSection>
            </>
        );
    }

    renderCompanies = (users) => {
        return <OldStyleSection name={this.props.translate("Report.EconomicGroup.FinalOwnerCompanies.SectionName")}
            hasData={!isNullOrUndefined(users) && users.length > 0} isBold isOpen><OldStyleTableWithHistory tableColumns={5} actualData={users} stripped resolveExpanded={this.props.resolveExpanded}
            classNames={{ "ess-table": true, "with-ellipsed-column": true, "ess-group": true }}
                head={() => <thead>
                    <tr>
                        <th className="col-1"><Translate id="Report.EconomicGroup.EconomicGroupLevel" /></th>
                        <th className="col-2"><Translate id="Report.EconomicGroup.EconomicGroupNegativeInfo" /></th>
                        <th><Translate id="Report.EconomicGroup.FinalBenefitsUser.Relation" /></th>
                        <th><Translate id ="Report.Common.ValidFrom"/></th>
                        <th style={{ width: "10%" }}><Translate id="Report.EconomicGroup.Legend.NI.Source"/></th>
                    </tr>
                </thead>}
                actualRow={(r) => this.renderCompanyRow(r)}
            />
        </OldStyleSection>
    }


    renderCompanyRow = (row) => {
        return <><tr key={row.entityId} className={`colorize ${this.getRowColorClass(1, 2)}`}>
            <td className='ellipsed-column' colSpan={5}>
                <div data-level={0} style={{ display: 'flex', flexWrap: "nowrap" }}>
                    <RelationLink entityId={row.id} reports={row.reports} entityName={row.name} showOnMobile={true} />
                    &nbsp;<PngFlag countryCode={row.countryCode} title={row.countryName} />&nbsp;
                    {this.renderEntityIdentification(row.birthDate, row.birthDateFormated, row.companyId)}
                </div>
            </td>
        </tr>
            {row.companies.map((company) => this.renderSubCompanyRow(company))}
        </>
    }

    renderSubCompanyRow = (company) => {
        return <tr key={company.parentId} className={`colorize ${this.getRowColorClass(2, 2)}`}>
            <td>
                <div data-level={1} style={{ display: 'flex', flexWrap: "nowrap" }}>
                    <RelationLink entityId={company.parentId} reports={company.reports} entityName={company.companyName} showOnMobile={true} />
                    &nbsp;<PngFlag countryCode={company.countryCode} title={company.countryName} />&nbsp;
                    {this.renderEntityIdentification(company.birthDate, company.birthDateFormated, company.companyId)}
                </div></td>
            <td data-label={this.props.translate('Report.EconomicGroup.NegativeInfo')}>
                {company.warnings !== null && company.warnings !== undefined && company.warnings.length > 0 && <div style={{ display: "flex", whiteSpace: "pre-wrap" }}>
                    {company.warnings.map((w, i) =>
                        <div key={w.code} className={`r-padded rel-warn rel-warn-status-${w.statusId}`} title={w.description}>{w.shortening}</div>
                    )}
                </div>}
            </td>
            <td>{company.relationType}</td>
            <td>{company.validFromFormatted}</td>
            <td title={company.sourceDescription}>{company.sourceShortening}</td>

        </tr>
    }

    renderEntityIdentification = (birthDate, birthDateFormated, companyId) => {
        if (isNullOrUndefined(birthDateFormated) && (isNullOrUndefined(companyId) || companyId.length === 0))
            return null;

        return <>({!isNullOrUndefined(birthDateFormated) ? birthDateFormated : companyId})</>
    }


    getRowColorClass = (level, maxLevel) => {
        let color = 19;

        if (maxLevel > 19)
            maxLevel = 19;

        if (level > 19)
            level = 19;

        if (level > maxLevel)
            level = maxLevel;

        if (maxLevel < 5)
            color = 10 + Math.floor(10 / maxLevel) * level;
        else if (maxLevel >= 5 && maxLevel < 10)
            color = 1 + Math.floor(20 / maxLevel) * level;
        else
            color = (20 - maxLevel) + level;

        return `color-${color}`;
    }

}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(EconomicGroupFinalOwners));
